module.exports = __webpack_public_path__ + "static/media/chulalearnhub2.fcca7c0a.png";